import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
  selector: 'forum-reader-toolbar',
  template: require('./forum.reader-toolbar.component.html')
})
export class ForumReaderToolbarComponent implements OnInit {
  @Input() currentThread: any;
  @Input() messages: any;
  @Output() onPaging = new EventEmitter<any>();

  pageNum: number = 1;
  pageSize: number = 20;
  sortDir: string = 'asc';
  sortLabel: string = '';

  constructor(private stateService: StateService) {}

  ngOnInit() {
    this.pageNum = parseInt(_.get(this.stateService.params, 'page_num', '1'), 10);
    this.pageSize = parseInt(_.get(this.stateService.params, 'page_size', '20'), 10);
    this.sortDir = _.get(this.stateService.params, 'sort_dir', 'asc');
    if (this.sortDir === 'asc') {
      this.sortLabel = 'Oldest First';
    } else {
      this.sortLabel = 'Newest First';
    }
  }

  setPaging (params) {
    this.pageNum = _.get(params, 'page_num', this.pageNum);
    this.pageSize = _.get(params, 'page_size', this.pageSize);
    this.doPaging();
};

  setSortDir(dir: string) {
    this.pageNum = 1;
    this.sortDir = dir;
    this.doPaging();
  }

  lastPage() {
    const count = _.get(this.currentThread, 'rel.threadParentCount', 1); // Min 1
    this.pageNum = Math.ceil(count / this.pageSize);
    this.doPaging();
  }

  private doPaging() {
    const p = {
      page_num: this.pageNum,
      page_size: this.pageSize,
      sort_dir: this.sortDir
    };
    this.onPaging.emit(p);
  }
}
